module.exports = __webpack_public_path__ + "static/media/cloud_logo.752c24fe.svg";